import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '@/context/AuthContext';
import { Icons } from '@/components/icons';

interface Props {
  from: string;
}

export function LoginPage({ from }: Props) {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = 'Login · Café Ledger';
  }, []);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await signIn(email, password);
    if (result.error) {
      setError(result.error.message);
    } else {
      navigate(from, { replace: true });
    }

    setLoading(false);
  };

  return (
    <div className="auth-screen">
      <form className="auth-card" onSubmit={handleSubmit}>
        <div className="logo">
          <div
            className="mark"
            style={{
              width: 36,
              height: 36,
              borderRadius: 11,
              background: 'var(--ink)',
              color: 'var(--bg)',
              display: 'grid',
              placeItems: 'center',
              fontSize: 18,
            }}
          >
            ☕
          </div>
          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontWeight: 500, fontSize: 18, letterSpacing: '-0.01em' }}>
              Café Ledger
            </div>
            <div style={{ fontSize: 10.5, color: 'var(--muted)', letterSpacing: '0.04em', textTransform: 'uppercase', marginTop: -2 }}>
              Café · Ops
            </div>
          </div>
        </div>

        <h1>Welcome back</h1>
        <p className="sub">Sign in to log receipts, review reimbursements, and track spend for the cafe.</p>

        <div className="field">
          <label>Email</label>
          <div style={{ position: 'relative' }}>
            <Icons.Mail size={14} stroke="var(--faint)" style={{ position: 'absolute', left: 11, top: 12 }} />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              style={{ paddingLeft: 32, width: '100%' }}
              required
            />
          </div>
        </div>

        <div className="field">
          <label>Password</label>
          <div style={{ position: 'relative' }}>
            <Icons.Lock size={14} stroke="var(--faint)" style={{ position: 'absolute', left: 11, top: 12 }} />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              style={{ paddingLeft: 32, width: '100%' }}
              required
              minLength={6}
            />
          </div>
        </div>

        {error && (
          <p style={{ marginTop: 4, padding: '8px 11px', borderRadius: 8, background: 'oklch(0.96 0.03 25)', color: 'oklch(0.45 0.16 25)', fontSize: 12.5 }}>
            {error}
          </p>
        )}

        <button className="btn primary" type="submit" disabled={loading} style={{ marginTop: 8 }}>
          {loading ? 'Please wait…' : 'Sign in'}
        </button>

        <div className="alt">Trouble signing in? Contact an admin.</div>
      </form>
    </div>
  );
}
